import { render, staticRenderFns } from "./IdentityModification.vue?vue&type=template&id=0e6813b8&scoped=true&"
import script from "./IdentityModification.vue?vue&type=script&lang=js&"
export * from "./IdentityModification.vue?vue&type=script&lang=js&"
import style0 from "./IdentityModification.vue?vue&type=style&index=0&id=0e6813b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6813b8",
  null
  
)

export default component.exports